import React from "react"
import PropTypes from "prop-types"
import {
  SettingsCard,
  SettingsCardTitle,
  SettingsCardContent,
} from "@modules/site/settings"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import { useApolloFragment } from "apollo-fragment-react"
import IncrementalBuildsSettings from "./IncrementalBuildsSettings"
import { EnableBuilds } from "./EnableBuilds"
import EnableBuildChecks from "./EnableBuildChecks"

const siteDataFragment = `
  fragment ExperimentalFeaturesSiteFragment on Site {
    buildsEnabled
    buildChecksEnabled
    incrementalBuildsEnabled
  }
`

const propTypes = {
  siteId: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
}

export default function BuildsSection({ siteId, organizationId }) {
  const { data: siteData } = useApolloFragment(siteDataFragment, siteId)

  if (!siteData) {
    return null
  }

  const buildsEnabled = siteData.buildsEnabled

  return (
    <SettingsCard>
      <SettingsCardTitle>
        {SiteSettingsSectionLabel[SiteSettingsSection.Builds]}
      </SettingsCardTitle>

      <SettingsCardContent
        css={theme => ({ display: `grid`, gridGap: theme.space[7] })}
      >
        <EnableBuilds siteId={siteId} buildsEnabled={siteData.buildsEnabled} />
        {buildsEnabled && (
          <React.Fragment>
            <EnableBuildChecks
              siteId={siteId}
              buildChecksEnabled={siteData.buildChecksEnabled}
            />

            <IncrementalBuildsSettings
              siteId={siteId}
              organizationId={organizationId}
              incrementalBuildsEnabled={siteData.incrementalBuildsEnabled}
            />
          </React.Fragment>
        )}
      </SettingsCardContent>
    </SettingsCard>
  )
}

BuildsSection.propTypes = propTypes
